// Bridges `CampaignSetupContext` setup state to the "Preview Ads" modal —
// the live equivalent of `domain/adPreview/fixtures.js`'s fixture registry.

import {
  derivePlatformSelectionFromSetup,
  platformIncludesMeta,
  platformIncludesGoogle,
} from 'components/Recommendations/Campaign/platform'
import {
  deriveCampaignTypeFromSetup,
  GoogleCampaignType,
} from 'components/Recommendations/EventCampaigns/Steps/Setup/Goals/campaignType'
import { PlacementPlatform } from './placementGroups'

const tcKey = (tc, tc_run_id) => `${tc}::${tc_run_id}`

// One option per (tc, tc_run_id) actually present in the setup's creatives —
// same source the rest of the wizard reads TCs from (setup.creatives is
// per-TC, keyed by tc/tc_run_id per this ticket's own Context).
export function getTasteClusterOptionsFromSetup(setup) {
  const creatives = Array.isArray(setup?.creatives) ? setup.creatives : []
  return creatives.map((creative) => ({
    value: tcKey(creative.tc, creative.tc_run_id),
    label: creative.tc ? creative.tc.replace(/[-_]/g, ' ') : '',
    tc: creative.tc,
    tc_run_id: creative.tc_run_id,
  }))
}

export function findCreativeByTcKey(creatives, key) {
  return (Array.isArray(creatives) ? creatives : []).find(
    (creative) => tcKey(creative.tc, creative.tc_run_id) === key,
  )
}

export function getActivePlatformsForSetup(setup) {
  const platform = derivePlatformSelectionFromSetup(setup)
  return [
    ...(platformIncludesMeta(platform) ? [PlacementPlatform.META] : []),
    ...(platformIncludesGoogle(platform) ? [PlacementPlatform.GOOGLE] : []),
  ]
}

// Which placement-group to render
// Meta: 'meta-single' or 'meta-carousel' based on `carousel_cards` presence.
// Google: 'google-display' or 'google-demand-gen' based on campaign type.
export function getVariantsForCreative(creative, setup) {
  const platforms = getActivePlatformsForSetup(setup)
  const variants = []

  if (platforms.includes(PlacementPlatform.META)) {
    const isCarousel = Array.isArray(creative?.carousel_cards) && creative.carousel_cards.length > 0
    variants.push(isCarousel ? 'meta-carousel' : 'meta-single')
  }

  if (platforms.includes(PlacementPlatform.GOOGLE)) {
    const campaignType = deriveCampaignTypeFromSetup(setup)
    variants.push(
      campaignType === GoogleCampaignType.demandGen ? 'google-demand-gen' : 'google-display',
    )
  }

  return variants
}

export function mergePageInfo(creative, pageInfo) {
  if (!creative) return creative
  if (!pageInfo?.page_name && !pageInfo?.profile_picture_url) return creative

  return {
    ...creative,
    page_name: pageInfo.page_name ?? creative.page_name,
    profile_picture_url: pageInfo.profile_picture_url ?? creative.profile_picture_url,
  }
}
